function getBrowserInfo() {
	// Controlla prima Chrome poiché include "Safari" nel suo UA
	const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

	// Safari specifico - verifica sia UA che vendor
	const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) && !isChrome; // esclude Chrome

	// Firefox
	const isFirefox = typeof InstallTrigger !== "undefined" || /firefox/i.test(navigator.userAgent);

	return { isChrome, isSafari, isFirefox };
}

function addClassToBody() {
	const classes = [];
	const { isSafari, isFirefox } = getBrowserInfo();

	if (isSafari) classes.push("is-safari");
	if (isFirefox) classes.push("is-firefox");

	if (classes.length > 0) {
		document.documentElement.classList.add(...classes);
	}
}

// Aspetta che il DOM sia caricato
if (document.readyState === "loading") {
	window.addEventListener("DOMContentLoaded", addClassToBody);
} else {
	addClassToBody();
}
